export default __webpack_public_path__ + "static/media/logo-no-background.2bf25e4b.png";